import { useCallback } from 'react';
import config from '../config';

export interface UseGoogleAnalyticsOptions {
  propertyIds?: string[];
  enabled?: boolean;
  filterPath?: (path: string) => string;
}

const useGoogleAnalytics = ({
  propertyIds = [config.googleAnalyticsId],
  enabled = true,
  filterPath = (path) => path,
}: UseGoogleAnalyticsOptions = { }) => {
  // Track events
  const trackEvent = useCallback((event: string, data: object) => {
    if (!enabled) {
      return;
    }

    if (event === 'purchase') {
      // Clear the previous ecommerce object to prevent multiple ecommerce events on a page from affecting each other.
      window.dataLayer?.push({ ecommerce: null });
    }

    propertyIds.forEach((propertyId) => {
      window.gtag?.('event', event, {
        ...data,
        send_to: propertyId,
      });
    });
  }, [propertyIds, enabled]);

  // Track page views
  const trackPageView = useCallback((manualPath?: string) => {
    const website = `${document.location.protocol}//${document.location.host}`;
    const path = filterPath(manualPath || (window.location.pathname + window.location.search));

    trackEvent('page_view', {
      page_location: `${website}/${path.replace(/^\//, '')}`,
    });
  }, [trackEvent, filterPath]);

  return {
    trackEvent,
    trackPageView,
  };
};

export default useGoogleAnalytics;
